import { useEffect, useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Banner from "@/pages/home/components/Banner";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import HotRanking from "@/pages/home/components/HotRanking";
import FavoritesStrip from "@/pages/home/components/FavoritesStrip";
import QuickLinks from "@/pages/home/components/QuickLinks";
import AboutStrip from "@/pages/home/components/AboutStrip";

const pageTitle = "51网址导航 - 分类齐全的实用网址导航平台";
const pageDescription =
  "51网址导航为您提供全面、分类清晰的网址导航服务，涵盖生活、购物、娱乐、学习等多个领域，帮助您快速访问常用网站，提高上网效率。";
const pageKeywords =
  "51网址导航,网址导航,网站分类,实用网址,便捷导航,常用网站,分类网站,上网导航";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    document.title = pageTitle;
    const setMeta = (name: string, content: string) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", name);
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", content);
    };
    setMeta("description", pageDescription);
    setMeta("keywords", pageKeywords);

    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-background-50" id="top">
      <Navbar overlay />

      <main className="flex-1 w-full">
        <h1 className="sr-only">{pageTitle}</h1>

        <Banner />

        <div className="relative z-20 w-full px-4 md:px-6 -mt-12 md:-mt-16">
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_300px] gap-4 md:gap-5">
            <CategoryGrid />
            <div className="space-y-4">
              <FavoritesStrip />
              <QuickLinks />
            </div>
          </div>
        </div>

        <section className="w-full px-4 md:px-6 mt-10 md:mt-14">
          <FeaturedSection />
        </section>

        <section className="w-full mt-10 md:mt-14 bg-background-100 border-y border-background-200">
          <div className="w-full px-4 md:px-6 py-10 md:py-14">
            <HotRanking />
          </div>
        </section>

        <section className="w-full px-4 md:px-6 mt-10 md:mt-14">
          <AboutStrip />
        </section>
      </main>

      <Footer />

      {showTop && (
        <div className="lg:hidden fixed bottom-4 right-4 z-40">
          <button
            type="button"
            aria-label="回到顶部"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 cursor-pointer animate-pop-in"
          >
            <i className="ri-arrow-up-line text-lg" />
          </button>
        </div>
      )}
    </div>
  );
}